import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, Fragment as _Fragment, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "u-mar-t-1"
}
const _hoisted_2 = {
  key: 1,
  class: "u-mar-t-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_steps = _resolveComponent("steps")!
  const _component_gebaeudedaten_ubersicht = _resolveComponent("gebaeudedaten-ubersicht")!
  const _component_titel_zelle = _resolveComponent("titel-zelle")!
  const _component_zelle = _resolveComponent("zelle")!
  const _component_zeile = _resolveComponent("zeile")!
  const _component_abschluss = _resolveComponent("abschluss")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_steps, {
      active: 5,
      items: _ctx.navItems,
      onGotoPage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('goto-page', $event)))
    }, null, 8, ["items"]),
    _createVNode(_component_abschluss, {
      produkt: "fh2024",
      "zeige-versichertes-objekt": true,
      "zeige-tarif": true,
      "zusaetzliche-SbLw": _ctx.zusaetzlicheSbLw,
      hinweistext: _ctx.hinweisWeitereUnterlagen,
      "preis-reduzierung-sanierung": _ctx.kernsanierung,
      onNextPage: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('next-page', $event))),
      onGotoPage: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('goto-page', $event)))
    }, _createSlots({
      "versichertes-objekt": _withCtx(() => [
        _createVNode(_component_gebaeudedaten_ubersicht),
        (_ctx.fhVersObjektZusatztext1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.fhVersObjektZusatztext1), 1))
          : _createCommentVNode("", true),
        (_ctx.fhVersObjektZusatztext2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.fhVersObjektZusatztext2), 1))
          : _createCommentVNode("", true)
      ]),
      "angaben-bestaetigen": _withCtx(() => [
        (_ctx.istNurVHV(_ctx.piniaStore.state))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _cache[8] || (_cache[8] = _createTextVNode(" Ja, der Antrag wurde gemäß meinen Angaben erstellt. Ich bestätige, dass es sich um ein Massiv- oder Fertighaus mit hartem Dach handelt, es sich nicht in einer Kleingartenanlage befindet und dass die ")),
              _createElementVNode("a", {
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.wechsleSichtbarkeit('mindestsicherungen')), ["prevent","stop"]))
              }, " tariflichen Mindestsicherungen "),
              _cache[9] || (_cache[9] = _createTextVNode(" erfüllt sind. Auf eine Beratung habe ich verzichtet und damit auf den Schadenersatzanspruch nach §6 Abs. 5 VVG. "))
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.istNurVGV(_ctx.piniaStore.state))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(" Ja, der Antrag wurde gemäß meiner Angaben erstellt. Ich bestätige, dass mein Haus nicht unter Denkmalschutz steht, kein Gewerbebetrieb und kein Schwimmbad im Haus vorhanden sind und es sich nicht in einer Kleingartenanlage befindet" + _toDisplayString(_ctx.elementarText) + ". Auf eine Beratung habe ich verzichtet und damit auf den Schadenersatzanspruch nach §6, Abs. 5 VVG. ", 1)
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.istVGVundVHV(_ctx.piniaStore.state))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _cache[10] || (_cache[10] = _createTextVNode(" Ja, der Antrag wurde gemäß meiner Angaben erstellt. Ich bestätige, dass mein Haus nicht unter Denkmalschutz steht, kein Gewerbebetrieb und kein Schwimmbad im Haus vorhanden sind und es sich nicht in einer Kleingartenanlage befindet. Die ")),
              _createElementVNode("a", {
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.wechsleSichtbarkeit('mindestsicherungen')), ["prevent","stop"]))
              }, " tariflichen Mindestsicherungen "),
              _createTextVNode(" sind erfüllt" + _toDisplayString(_ctx.elementarText) + ". Auf eine Beratung habe ich verzichtet und damit auf den Schadenersatzanspruch nach §6, Abs. 5 VVG. ", 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 2
    }, [
      (_ctx.hatZusatzmodule)
        ? {
            name: "zusatzmodule",
            fn: _withCtx(() => [
              _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.zusatzModule), 1)
            ]),
            key: "0"
          }
        : undefined,
      (_ctx.piniaStore.state.ferienhaus.vgv.tarifinformationen.extraSelbstbeteiligung)
        ? {
            name: "zusaetzliche-selbstbeteiligung",
            fn: _withCtx(() => [
              _createVNode(_component_zeile, { class: "u-mar-t-2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_titel_zelle, {
                    breite: 3,
                    class: "o-grid__cell--4",
                    "ausrichtung-responsiv": false,
                    "vertikal-zentrieren": false
                  }, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createTextVNode(" Zu­sätz­liche Selbst­be­teili­gung je Grund­ge­fahr-Schaden  ")
                    ])),
                    _: 1,
                    __: [7]
                  }),
                  _createVNode(_component_zelle, {
                    breite: 9,
                    class: "o-grid__cell--8",
                    "data-cy": "zusaetzlicheSb"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.formatCurrency(_ctx.piniaStore.state.ferienhaus.vgv.tarifinformationen.extraSelbstbeteiligung)), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            key: "1"
          }
        : undefined
    ]), 1032, ["zusaetzliche-SbLw", "hinweistext", "preis-reduzierung-sanierung"]),
    (_ctx.istSichtbar('mindestsicherungen'))
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 0,
          id: "mindestsicherungen",
          titel: "Tarifliche Mindestsicherungen",
          text: "Unter einer Mindestsicherung der Wohnung versteht die GEV die Sicherung von Haustüren bzw. Wohnungsabschlusstüren durch ein Zylinderschloss mit Sicherheitsbeschlag (von außen nicht abschraubbar und über bündig montierte – max. 5 mm überstehende – Schließzylinder). Gleiches gilt für die Sicherung von weiteren Außentüren (z.B. Terrassen-, Kellertüren). Trifft das nicht zu, kontaktieren Sie uns bitte unter 040 3766 3366.",
          onCloseModal: _cache[5] || (_cache[5] = ($event: any) => (_ctx.wechsleSichtbarkeit('mindestsicherungen')))
        }))
      : _createCommentVNode("", true)
  ], 64))
}